export default __webpack_public_path__ + "static/media/ArcheryLogo.95a13cce.png";